export default __webpack_public_path__ + "static/media/logo-election2020.eb92544c.svg";